import { Grid } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { InfoIcon } from '../CustomIcons';
import { BoxWrapper, ButtonWrapper, ContentText, DisabledWrapper, Title } from './styles';

const DisabledMask = () => {
  const { t } = useTranslation('overview');

  return (
    <DisabledWrapper container data-testid="disabled-component">
      <Grid container direction={'column'} alignItems={'center'} justifyContent={'center'}>
        <Grid item marginY={'5%'}>
          <InfoIcon />
        </Grid>
        <Grid item alignItems={'center'} textAlign={'center'}>
          <BoxWrapper>
            <Title variant="h2">{t('this area is disabled')}</Title>
          </BoxWrapper>
          <BoxWrapper>
            <ContentText variant="body2">
              <Trans
                i18nKey="you need to have other subscription plan"
                ns="overview"
                components={[<strong />]}
                values={{ subscribePlan: 'Payflow Pro' }}
              />
            </ContentText>
          </BoxWrapper>
          <BoxWrapper>
            <ButtonWrapper href="https://calendly.com/ramon-payflow/payflow-como-funciona">
              {t('i want to know more')}
            </ButtonWrapper>
          </BoxWrapper>
        </Grid>
      </Grid>
    </DisabledWrapper>
  );
};

export default DisabledMask;
